import { useMemo, useCallback } from 'react'

import { BASE_URL } from '../constants'

import useFetch from '../hooks/useFetch'
import { useToken } from '../auth/hooks'

export const useItems = (api_url) =>
  useFetch(`${BASE_URL}api/${api_url}`, undefined, [api_url])

export const useItem = (api_url, id) => {
  const token = useToken()
  const item_url = useMemo(() => `${BASE_URL}api/${api_url}/${id}`, [
    api_url,
    id,
  ])
  const auth_headers = useMemo(
    () => ({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }),
    [token]
  )

  const [item_state, item_actions] = useFetch(item_url)
  const actions = useMemo(
    () => ({
      save: (i) =>
        fetch(item_url, {
          headers: auth_headers,
          method: 'PUT',
          body: JSON.stringify(i),
        }),
      remove: () =>
        fetch(item_url, {
          headers: auth_headers,
          method: 'DELETE',
        }),
    }),
    [item_url, auth_headers]
  )
  return [item_state, { ...actions, ...item_actions }]
}

export const useCreateItem = (api_url) => {
  const token = useToken()
  const create = useCallback(
    async (item) =>
      await fetch(`${BASE_URL}api/${api_url}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(item),
      }),
    [token, api_url]
  )

  return create
}
